import IconButton from '@material-ui/core/Button';
import React from 'react';
import HomeIcon from '@material-ui/icons/Home';
import useTableButtonStyle from '../directory-content/TableButtonStyle';

const HomeButton = (props) => {
    const { setSelectedFileSystemNodePath } = props;
    const classes = useTableButtonStyle();

    const handleClick = () => {
        setSelectedFileSystemNodePath([], 'directory');
    }

    return (<>
        <IconButton size="small" className={classes.root} onClick={handleClick}>
            <HomeIcon size="small"/>
        </IconButton>
    </>);
}

export default HomeButton;